import { useHasChanged } from "@app/modules/util";
import classNames from "classnames";
import React, { memo, useEffect, useState } from "react";

export interface OffcanvasProps {
    isOpen: boolean;
    position?: "start" | "end" | "top" | "bottom";
    backdrop?: boolean | "static";
    toggle: () => void;
    className?: string;
    children?: React.ReactNode;
    delay?: number;
}

export const Offcanvas = memo((props: OffcanvasProps) => {
    props = {
        backdrop: true,
        delay: 300,
        position: "start",
        ...props,
    };
    const {
        backdrop,
        children,
        delay,
        className,
        isOpen,
        position,
        toggle,
    } = props;

    // Need to track when the backdrop is animating
    const [animating, setAnimating] = useState(false);
    const isOpenChanged = useHasChanged(isOpen);
    useEffect(() => {
        if (isOpenChanged) {
            setAnimating(true);
            setTimeout(() => {
                setAnimating(false);
            }, delay);
            // We need to disable scrolling on the body
            document.body.classList.toggle("noscroll", isOpen);
        }
    }, [isOpen]);

    return (
        <>
            <div
                className={classNames(
                    className,
                    "offcanvas",
                    "offcanvas-" +  position,
                    {
                        show: (isOpen && !animating) || (!isOpen && (animating || isOpenChanged)),
                        showing: animating && isOpen,
                        hiding: animating && !isOpen,
                    },
                )}
                tabIndex={-1}
            >{children}</div>
            {(backdrop === undefined || backdrop) && (isOpen || animating) && (
                <div {
                    ...{
                        className: classNames(
                            "offcanvas-backdrop",
                            "fade",
                            {
                                show: isOpen,
                            },
                        ),
                        onClick: backdrop === "static" ? undefined : toggle,
                    }
                }
                ></div>
            )}
        </>
    );
});
